<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">문의 선택</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <select>
                        <option>계정 문의</option>
                        <option>서비스 문의</option>
                      </select>
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">제목</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="제목을 입력해주세요." v-model="inquireDetail.boardTitle">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">내용</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <textarea placeholder="문의에 따라 답변 소요 시간이 길어질 수 있습니다." v-model="inquireDetail.boardDescription"></textarea>
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="fnSave">문의 등록</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      inquireDetail: {}
    }
  },
  methods: {
    fnSave: function () {
      setTimeout(() => {
        this.$Util.modalAlert({message: '문의가 접수되었습니다.<br/>문의에 따라 답변 소요 시간이 길어질 수 있습니다.'})
        this.inquireDetail = {}
      }, 200)
    }
  }
}
</script>
